import { useEffect, useRef, useState } from "react";
import { calendarLayout } from "./calendarConstants";

export default function useMaxVisibleReservations(weeksInView: number) {
  const gridRef = useRef<HTMLDivElement | null>(null);
  const [maxVisibleReservations, setMaxVisibleReservations] = useState(3);

  useEffect(() => {
    const grid = gridRef.current;
    if (!grid) return;
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      const height = entry.contentRect.height;
      const cellHeight = height / weeksInView;
      const available =
        cellHeight - calendarLayout.dayHeaderHeight - calendarLayout.dayPadding;
      const nextMax = Math.max(
        0,
        Math.floor(available / calendarLayout.reservationRowHeight),
      );
      setMaxVisibleReservations(nextMax);
    });
    observer.observe(grid);
    return () => observer.disconnect();
  }, [weeksInView]);

  return { gridRef, maxVisibleReservations };
}
